import { Set } from 'src/state/types'
import { set } from 'src/state/utils'

interface ModelDynamicContent {
  // State
  legalNotices: null | {
    fr: string
    en: string
  }
  privacyPolicy: null | {
    fr: string
    en: string
  }
  faq: null | {
    fr: { question: string; answer: string }[]
    en: { question: string; answer: string }[]
  }
  // Version of the `tracks/sophrology/music-only/*.m4a` files. Bump it in the
  // `dynamic-content/audioConfig` Firestore doc to force cached devices to
  // re-download those tracks. Falls back to MUSIC_ONLY_VERSION in
  // use-audio-file.native.ts when absent.
  musicOnlyVersion: null | number

  // Actions
  setLegalNotices: Set<this, 'legalNotices'>
  setPrivacyPolicy: Set<this, 'privacyPolicy'>
  setFaq: Set<this, 'faq'>
  setMusicOnlyVersion: Set<this, 'musicOnlyVersion'>
}

export const modelDynamicContent: ModelDynamicContent = {
  // State
  legalNotices: null,
  privacyPolicy: null,
  faq: null,
  musicOnlyVersion: null,

  // Actions
  setLegalNotices: set('legalNotices'),
  setPrivacyPolicy: set('privacyPolicy'),
  setFaq: set('faq'),
  setMusicOnlyVersion: set('musicOnlyVersion'),
}
